export default "__VITE_ASSET__BbzEKWSo__"